// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React from "react";
import { Rate, RateProps } from "antd";
import { RateStarEmpty, RateStarFilled, RateStarHalf } from "../assets";

interface RatingProps extends RateProps {
  color: string;
  size: number;
  setValue?: (value: number) => void;
}

export function StarRating({
  value,
  disabled,
  color,
  size,
  style,
  setValue,
}: RatingProps) {
  const handleClick = (newValue: number) => {
    if (!disabled) setValue(newValue);
  };

  const stars = Array.from({ length: 5 }, (_, index) => {
    const isHalf =
      index < value && index + 1 > value && !Number.isInteger(value);
    const isFilled = index < value;

    return (
      <span
        key={index}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          margin: "0 5px",
        }}
        onClick={() => handleClick(index + 1)}
      >
        {isHalf ? (
          <RateStarHalf color={color} width={size} height={size} />
        ) : isFilled ? (
          <RateStarFilled color={color} width={size} height={size} />
        ) : (
          <RateStarEmpty color={color} width={size} height={size} />
        )}
      </span>
    );
  });

  return <div style={style}>{stars}</div>;
}
